// interface requires setPageData and setLayoutData
import {
    setPageData, setLayoutData, buildPage, buildRendering,
} from '@/sitecore/sitecore-data-interface';

export function processData(rawData) {
    if (!rawData) {
        throw new Error('data.js: Page data is empty.');
    }
    return {
        pageData: setPageData(rawData),
        layout: setLayoutData(rawData),
    };
}

export function encodeData(pageData) {
    if (!pageData) {
        throw new Error('data.js: Page data is empty.');
    }

    return buildPage(pageData);
}

export function encodeRendering(renderingData, componentData, isNew) {
    if (!renderingData) {
        throw new Error('data.js: Rendering data is empty.');
    }

    return buildRendering(renderingData, componentData, isNew);
}
